const apiMeta = {
  // 生成器 _meta（docUrl 指向测试环境文档站）已删除：运行时零引用，
  // 且 test-ws 字符串会被发布校验（scripts/validate test-ws 黑名单）拦截 master 上线。
  // 后续 service 同步（zt-service-contract-sync）落正式层时须同步去掉 _meta 块
  apis: {
    '/jxsjmobile4/team260804/get_config': {
      title: '获取活动配置',
      uri: '/jxsjmobile4/team260804/get_config',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        entry_source: {
          desc: '进入来源（sms_share：短信分享，team_share：队伍海报分享，direct或不传：直接进入）',
          data: ''
        },
        from_team_id: {
          desc: '来源队伍ID（entry_source=team_share时记录）',
          data: ''
        },
        share_code: {
          desc: '分享人个人分享码（携带时用于回流识别，分享人记录到其inviter_account）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20102': '领奖时间配置缺失',
        '-20103': '领奖未开启',
        '-20104': '领奖已结束'
      },
      services: ['passport'],
      result: {
        'data{}': {
          account: '脱敏通行证（未登录返回空字符串）',
          activity_status: '活动阶段（0：未开始，1：进行中，2：已结束）',
          get_prize_status: '领奖时间状态（0：未开始，1：进行中，2：已结束）',
          has_share_prize: '是否已触发首次分享海报奖励（0：否，1：是）',
          player_type: '玩家身份（0：未判断，1：新玩家，2：老玩家）',
          review_status: '回顾状态（0：未完成，1：已完成）',
          share_code: '个人分享码（用于生成海报/邀请链接及回流识别，未登录返回空字符串）',
          team_status: '队伍状态（0：无队伍，1：已有队伍）'
        }
      }
    },
    '/jxsjmobile4/team260804/get_prize_list': {
      title: '奖励列表',
      uri: '/jxsjmobile4/team260804/get_prize_list',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20102': '领奖时间配置缺失',
        '-20103': '领奖未开启',
        '-20104': '领奖已结束'
      },
      services: ['passport'],
      result: {
        'data{}': {
          bind_role: '已绑定角色信息',
          prize_list: '奖励列表',
          prize_time: '领奖时间状态（0：未到领奖时间，1：可领奖，2：已过领奖时间）'
        },
        'data{}.prize_list[]': {
          claim_status: '领奖状态（0：不可领奖，1：可领奖，2：已领奖）',
          prize_id: '奖励标识（share_poster：首次海报奖励）'
        }
      }
    },
    '/jxsjmobile4/team260804/claim_prize': {
      title: '领取奖励',
      uri: '/jxsjmobile4/team260804/claim_prize',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        prize_id: {
          desc: '奖励标识',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20102': '领奖时间配置缺失',
        '-20103': '领奖未开启',
        '-20104': '领奖已结束',
        '-20122': '请先绑定角色',
        '-20133': '奖励不存在',
        '-20134': '奖励已领取',
        '-20135': '未满足领取条件'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/team_config': {
      title: '队伍信息',
      uri: '/jxsjmobile4/team260804/team_config',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20105': '组队时间未配置',
        '-20108': '组队时间未开始',
        '-20109': '组队时间已结束'
      },
      services: ['passport'],
      result: {
        'data{}': {
          is_nickname_modified: '是否已修改昵称（0：未修改，1：已修改）',
          team_id: '队伍id',
          team_members: '队伍成员',
          team_status: '组队时间状态（0：未开始，1：进行中，2：已结束）'
        },
        'data{}.team_members[]': {
          nickname: '昵称',
          num: '头像编号'
        }
      }
    },
    '/jxsjmobile4/team260804/get_team_info_by_id': {
      title: '队伍信息（客态）',
      uri: '/jxsjmobile4/team260804/get_team_info_by_id',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        share_code: {
          desc: '分享人个人分享码（邀请链接携带，用于标记邀请人）',
          data: ''
        },
        team_id: {
          desc: '队伍id（邀请链接携带）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20105': '组队时间未配置',
        '-20108': '组队时间未开始',
        '-20109': '组队时间已结束',
        '-20125': '请输入正确的队伍邀请码'
      },
      services: ['passport'],
      result: {
        'data{}': {
          is_full: '队伍是否已满（0：未满，1：已满）',
          member_count: '当前成员数',
          team_id: '队伍id',
          team_members: '队伍成员',
          team_status: '组队时间状态（0：未开始，1：进行中，2：已结束）'
        },
        'data{}.team_members[]': {
          is_inviter: '是否为邀请人（0：否，1：是；携带share_code且分享人在队伍中时对应成员为1）',
          is_self: '是否本人（0：否，1：是）',
          nickname: '昵称',
          num: '头像编号'
        }
      }
    },
    '/jxsjmobile4/team260804/create_team': {
      title: '创建队伍',
      uri: '/jxsjmobile4/team260804/create_team',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20105': '组队时间未配置',
        '-20108': '组队时间未开始',
        '-20109': '组队时间已结束',
        '-20124': '当前账号已有队伍'
      },
      services: ['passport'],
      result: {
        'data{}': {
          next: '下一步建议（poster=生成海报，recall_list=好友召回列表）',
          team_id: '队伍id'
        }
      }
    },
    '/jxsjmobile4/team260804/join_team': {
      title: '加入队伍',
      uri: '/jxsjmobile4/team260804/join_team',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        team_id: {
          desc: '队伍id',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20105': '组队时间未配置',
        '-20108': '组队时间未开始',
        '-20109': '组队时间已结束',
        '-20124': '当前账号已有队伍',
        '-20125': '请输入正确的队伍邀请码',
        '-20126': '该队伍成员已达到上限'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/update_member_msg': {
      title: '修改队伍信息',
      uri: '/jxsjmobile4/team260804/update_member_msg',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        nickname: {
          desc: '昵称',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20105': '组队时间未配置',
        '-20108': '组队时间未开始',
        '-20109': '组队时间已结束',
        '-20129': '该账号未组队',
        '-20130': '请输入修改的昵称',
        '-20131': '昵称含有敏感词汇，请修改后重新提交！',
        '-20137': '昵称只能修改一次',
        '-20138': '昵称最多8个字符'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/bind_role': {
      title: '绑定角色',
      uri: '/jxsjmobile4/team260804/bind_role',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        role: {
          desc: '角色昵称',
          data: ''
        },
        role_id: {
          desc: '角色ID',
          data: ''
        },
        server: {
          desc: '服务器名',
          data: ''
        },
        server_id: {
          desc: '服务器ID',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20118': '请选择服',
        '-20119': '请选择角色',
        '-20132': '该账号已绑定角色',
        '-20149': '该服已绑定该角色'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/get_review': {
      title: '老玩家回顾数据',
      uri: '/jxsjmobile4/team260804/get_review',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20141': '仅老玩家可参与回顾'
      },
      services: ['passport'],
      result: {
        'data{}': {
          review_data: '老玩家回顾数据（本期 Mock，字段对齐大数据字段表）'
        },
        'data{}.review_data{}': {
          account_id: '老玩家账号ID',
          baihutang_cnt: '白虎堂参与次数',
          baitan_cuiyu: '摆摊翠玉数量（交易统计）',
          baitan_yuanbao: '摆摊元宝数量（交易统计）',
          disciple_names: '得意弟子名称列表（收徒记录）',
          first_hit_count: '家族首刀次数（三才首领+秦始皇陵）',
          first_login_date: '首次登录日期（Y-m-d）',
          fudai_cnt: '福袋开启次数',
          hengdaoshu_cnt: '横刀书参与次数',
          hengdaoshu_time: '横刀书累计时长（分钟）',
          is_baobei: '是否家族宝贝（0：否，1：是）',
          is_fuzuzhang: '是否副族长（0：否，1：是）',
          is_zhanglao: '是否长老（0：否，1：是）',
          is_zuzhang: '是否族长（0：否，1：是）',
          jianxia_score: '剑侠分（最终综合评分）',
          last_hit_count: '家族尾刀次数（三才首领+秦始皇陵）',
          linan_cnt: '临安占领次数（领土战+逐鹿）',
          lingtu_cnt: '领土占领次数',
          master_date: '拜师纪念日期（Y-m-d，取最早拜师记录）',
          master_name: '师父名称（取最早拜师记录）',
          p2p_cnt: 'P2P交易次数（交易统计）',
          partner_date: '侠侣结缘纪念日期（Y-m-d，取最新结缘记录）',
          partner_name: '侠侣名称（取最新结缘记录）',
          role_body_type: '体型编号（1：成男）',
          role_gender: '角色性别',
          role_id: '主角色（游玩时间最久）角色ID',
          role_level: '角色等级',
          role_menpai_id: '门派ID',
          role_menpai_name: '门派名称',
          role_name: '主角色角色名称',
          role_online_time: '累计在线时长（分钟）',
          songjin_cnt: '宋金战场参与次数',
          tag_list: '玩家标签列表：按稀有度分组（键3/2/1，3最高）的对象数组，每项 {name, desc}，desc 为达成条件描述（2026-09-21 实测）',
          tianxia_cnt: '逐鹿占领次数',
          tong_days: '加入家族天数',
          tong_id: '家族ID',
          tong_name: '家族名称',
          tong_position_list: '家族职位列表（英文逗号分隔）'
        }
      }
    },
    '/jxsjmobile4/team260804/finish_review': {
      title: '标记回顾完成',
      uri: '/jxsjmobile4/team260804/finish_review',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20141': '仅老玩家可参与回顾'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/claim_share_prize': {
      title: '首次分享海报触发外观奖励',
      uri: '/jxsjmobile4/team260804/claim_share_prize',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        qrcode_type: {
          desc: '二维码类型（team/home/download，可选）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20129': '该账号未组队'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsjmobile4/team260804/get_poster': {
      title: '海报基础信息',
      uri: '/jxsjmobile4/team260804/get_poster',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式'
      },
      services: ['passport'],
      result: {
        'data{}': {
          body_type: '体类型(有1-成男、2-成女、3-少女、4-少年)',
          download_url: '下载URL',
          invite_params: '邀请参数',
          menpai_id: '门派ID',
          register_date: '注册日期',
          tag_list: '预设标签列表：按稀有度分组（键3/2/1，3最高）的对象数组，每项 {name, desc}，desc 为达成条件描述（2026-09-21 实测）'
        },
        'data{}.invite_params{}': {
          share_code: '个人分享码（用于生成海报/邀请链接及回流识别，未登录返回空字符串）',
          team_id: '队伍id'
        }
      }
    },
    '/jxsjmobile4/team260804/get_recall_list': {
      title: '可召回好友列表',
      uri: '/jxsjmobile4/team260804/get_recall_list',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20142': '暂无可召回好友列表'
      },
      services: ['passport'],
      result: {
        'data{}': {
          recall_list: '可召回好友列表'
        },
        'data{}.recall_list[]': {
          has_sent_sms: '是否发送短信（0-未发送，1-已发送）',
          relation: '关系',
          relation_type: '关系类型',
          role_name: '角色名称'
        }
      }
    },
    '/jxsjmobile4/team260804/recall_friend': {
      title: '好友召回（发送召回短信）',
      uri: '/jxsjmobile4/team260804/recall_friend',
      method: ['GET', 'POST'],
      params: {
        _mock_passport_account: {
          desc: '通行证（模拟登录，测试环境使用）',
          data: ''
        },
        relation_type: {
          desc: '关系标识，取自 get_recall_list 返回的 relation_type（结缘 jieyuan_role_name / 师父 shifu_role_name / 徒弟 tudi_role_name1-3）',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20143': '请选择要召回的好友',
        '-20144': '仅老玩家可发起好友召回',
        '-20148': '该好友关系不存在',
        '-20150': '该好友已发送过召回短信'
      },
      services: ['passport'],
      result: {
        'data{}': []
      }
    }
  }
};

export default apiMeta;
